import { AxDataTable } from "@/components/ax/dataTable/AxDataTable";
import { DeleteRowConfirmationDialog } from "@/components/ax/dataTable/DeleteRowConfirmationDialog";
import { showSuccess, showApiError } from "@/lib/toast";
import { StoreDetails, StoreSalePack } from "@/lib/types";
import { deleteStoreSalePack, getStoreSalePack } from "@/sideEffects/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ColumnDef } from "@tanstack/react-table";
import { useTranslation } from "react-i18next";
import { AddStoreSalePackDialog } from "./AddStoreSalePackDialog";

interface Props {
  storeDetails: StoreDetails;
}

export const UpdateStoreSalePack: React.FC<Props> = ({ storeDetails }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const deleteStoreSalePackMutation = useMutation({
    mutationFn: (storeSalePackId: string) => deleteStoreSalePack(storeSalePackId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["getStoreSalePack"] });
      showSuccess(t("common.deletedSuccess"));
    },
    onError: showApiError,
  });

  const columns: ColumnDef<StoreSalePack>[] = [
    {
      accessorKey: "name",
      header: t("common.name"),
    },
    {
      accessorKey: "customerKey",
      header: t("common.customerKey"),
    },
    {
      accessorKey: "id",
      header: () => "",
      cell: ({ row }) => {
        return (
          <div className="flex items-center justify-end gap-2">
            <DeleteRowConfirmationDialog
              onConfirmDelete={() => deleteStoreSalePackMutation.mutate(row.original.id)}
              isLoading={
                deleteStoreSalePackMutation.isPending && deleteStoreSalePackMutation.variables === row.original.id
              }
            />
          </div>
        );
      },
    },
  ];

  return (
    <AxDataTable
      columns={columns}
      fetcher={getStoreSalePack}
      uniqQueryKey={"getStoreSalePack"}
      getRowId={(row) => row.id.toString()}
      dynamicRequestParams={{ storeId: String(storeDetails?.id) }}
      extraHeader={<AddStoreSalePackDialog storeDetails={storeDetails} />}
    />
  );
};
